<div class="modal-loading-overlay" *ngIf="isUploading">
  <div class="modal-loading-content">
    <mat-spinner diameter="48"></mat-spinner>
    <span>{{ 'stock.importArrivals.modal.loading' | translate }}</span>
  </div>
</div>

<div class="modal-header">
  <h2 class="modal-title">{{ 'stock.importArrivals.modal.title' | translate }}</h2>

  <button
    mat-icon-button
    type="button"
    class="close-button"
    (click)="cancel()"
    [disabled]="isUploading"
    [attr.aria-label]="'stock.importArrivals.modal.close' | translate">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="dropzone"
     (drop)="onDrop($event)"
     (dragover)="onDragOver($event)"
     (dragleave)="onDragLeave()"
     [class.dragover]="isDragOver"
     [class.disabled]="isUploading">
  <mat-icon class="drop-icon">cloud_upload</mat-icon>

  <div class="drop-content">
    <span class="hint">{{ 'stock.importArrivals.modal.dropHint' | translate }}</span>

    <label class="file-choose">
      <input
        #fileInput
        type="file"
        (change)="onFileSelected($event)"
        [disabled]="isUploading"
        accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" />
      <span class="file-choose-button">{{ 'stock.importArrivals.modal.chooseFile' | translate }}</span>
    </label>

    <span *ngIf="selectedFile" class="filename">
      {{ 'stock.importArrivals.modal.selectedFile' | translate:{ name: selectedFile.name } }}
    </span>
  </div>
</div>

<div class="success-box" *ngIf="importResult?.successLineCount > 0">
  <div class="success-box-content">
    {{ 'stock.importArrivals.modal.success_description' | translate:{ count: importResult?.successLineCount } }}
  </div>
</div>

<details class="error-accordion error-accordion-highlight" *ngIf="importResult?.errorLineCount">
  <summary class="error-summary">
    <span>
      {{ 'stock.importArrivals.modal.errors.summary' | translate:{
      errorCount: importResult?.errorLineCount,
      totalCount: importResult?.errorLineCount + importResult?.successLineCount,
      errorLabel: (importResult?.errorLineCount || 0) > 1
        ? ('stock.importArrivals.modal.errors.labelPlural' | translate)
        : ('stock.importArrivals.modal.errors.labelSingular' | translate)
    } }}
    </span>
  </summary>

  <div class="error-panel">
    <span class="error-help">
      {{ 'stock.importArrivals.modal.errors.helpLine1' | translate }}
      <br>
      {{ 'stock.importArrivals.modal.errors.helpLine2' | translate }}
    </span>

    <div class="error-list">
      <div class="error-item" *ngFor="let error of importResult?.errors">
        <div class="error-line">
          {{ 'stock.importArrivals.modal.errors.line' | translate:{
          lineNumber: error.lineNumber,
          message: error.message
        } }}
        </div>
      </div>
    </div>
  </div>
</details>

<details class="example-accordion">
  <summary class="example-summary">
    <span>{{ 'stock.importArrivals.modal.example.title' | translate }}</span>
  </summary>

  <div class="example-panel">
    <pre class="example-preview">{{ exampleContent }}</pre>
  </div>
</details>

<div class="actions">
  <button mat-stroked-button class="cancel-button" (click)="cancel()" [disabled]="isUploading">
    {{ 'common.confirm-modal.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" [disabled]="!selectedFile || isUploading" (click)="import()">
    {{ 'stock.importArrivals.button' | translate }}
  </button>
</div>
